import Cookies from "js-cookie";
import { usermenu } from "@/api/usermenu";
const schoolCode = "school-Code"; //学校识别码
const TokenKey = "Admin-Token";
const UuidKey = "Uu-id";
const schoolIdKey = "school-Id"; //学校id
const roleIdKey = "role-Id";
const Nickname = "Nick-Name";
const HeadPath = "Head-Path";
const getuserPhonekey = "User-Phone";
const getuserNamekey = "User-Name";
const rank = "rank";
const IsAdmin = "isAdmin";
const organFlag = "organFlag"; // 机构登录状态
const areaId = "areaId";
const loginInfoId = "loginInfoId";

const roleType = 'roleType'

const parentId = 'parentId'

const terrace = 'terrace'

export function getTerrace() {
    return Cookies.get(terrace)
}
export function setTerrace(value) {
    return Cookies.set(terrace, value)
}
export function removeTerrace() {
    return Cookies.remove(terrace)
}

export function getParentId() {
    return Cookies.get(parentId)
}
export function setParentId(id) {
    return Cookies.set(parentId, id)
}
export function removeParentId() {
    return Cookies.remove(parentId)
}

export function getroleType() {
    return Cookies.get(roleType)
}
export function setroleType(type) {
    return Cookies.set(roleType, type)
}
export function removeroleType() {
    return Cookies.remove(roleType)
}

export function getloginInfoId() {
  return Cookies.get(loginInfoId);
}
export function setloginInfoId(id) {
  return Cookies.set(loginInfoId, id);
}
export function removeloginInfoId() {
  return Cookies.remove(loginInfoId);
}

export function getIsAdmin() {
  return Cookies.get(IsAdmin);
}
export function setIsAdmin(isAdmin) {
  return Cookies.set(IsAdmin, isAdmin);
}
export function removeIsAdmin() {
  return Cookies.remove(IsAdmin);
}

export function getorganFlag() {
  return Cookies.get(organFlag);
}
export function setorganFlag(Flag) {
  return Cookies.set(organFlag, Flag);
}
export function removeorganFlag() {
  return Cookies.remove(organFlag);
}

export function getareaId() {
  return Cookies.get(areaId);
}
export function setareaId(aId) {
  return Cookies.set(areaId, aId);
}
export function removeareaId() {
  return Cookies.remove(areaId);
}

export function getrank() {
  return Cookies.get(rank);
}
export function setrank(ranka) {
  return Cookies.set(rank, ranka);
}
export function removerank() {
  return Cookies.remove(rank);
}

export function getheadPath() {
  return Cookies.get(HeadPath);
}

export function setheadPath(headPath) {
  return Cookies.set(HeadPath, headPath);
}

export function removeheadPath() {
  return Cookies.remove(HeadPath);
}

export function getuserPhone() {
  return Cookies.get(getuserPhonekey);
}

export function setuserPhone(phone) {
  return Cookies.set(getuserPhonekey, phone);
}

export function removeuserPhone() {
  return Cookies.remove(getuserPhonekey);
}

export function getuserName() {
  return Cookies.get(getuserNamekey);
}

export function setuserName(username) {
  return Cookies.set(getuserNamekey, username);
}

export function removeuserName() {
  return Cookies.remove(getuserNamekey);
}

export function getschoolCode() {
  return Cookies.get(schoolCode);
}

export function setschoolCode(Code) {
  return Cookies.set(schoolCode, Code);
}

export function removeschoolCode() {
  return Cookies.remove(schoolCode);
}

export function getToken() {
  // return sessionStorage.getItem("Admin-Token")
  return Cookies.get(TokenKey);
}

export function setToken(token) {
  // return sessionStorage.setItem("Admin-Token", token);
  return Cookies.set(TokenKey, token);
}

export function removeToken() {
  // return sessionStorage.removeItem("Admin-Token")
  return Cookies.remove(TokenKey);
}

export function getUuid() {
  return Cookies.get(UuidKey);
}

export function setUuid(uuid) {
  return Cookies.set(UuidKey, uuid);
}

export function removeUuid() {
  return Cookies.remove(UuidKey);
}

export function getschoolId() {
  return Cookies.get(schoolIdKey);
}

export function setschoolId(schoolId) {
  return Cookies.set(schoolIdKey, schoolId);
}

export function removeschoolId() {
  return Cookies.remove(schoolIdKey);
}

export function getroleId() {
  return Cookies.get(roleIdKey);
}

export function setroleId(roleId) {
  return Cookies.set(roleIdKey, roleId);
}

export function removeroleId() {
  return Cookies.remove(roleIdKey);
}

export function getNickname() {
  return Cookies.get(Nickname);
}

export function setNickname(nickname) {
  return Cookies.set(Nickname, nickname);
}

export function removeNickname() {
  return Cookies.remove(Nickname);
}

//  区分人员
export function differently() {
  // rank == 1 && admin == 1 超管          1
  // rank == 2 && admin == 1 区管          2
  // rank == 3 && admin == 1 校管          3
  // rank == 3 && admin == ''老师          4
  // rank == 5 学生                        5
  // rank == 10 职工                       6
  // rank == 8  散户                       7
  let identity = "";
  if (getrank() == 1 && getIsAdmin() == 1) {
    identity = 1;
  } else if (getrank() == 1 && getIsAdmin() == "") {
    identity = 1;
  } else if (getrank() == 2 && getIsAdmin() == 1) {
    identity = 2;
  } else if (getrank() == 3 && getIsAdmin() == 1) {
    identity = 3;
  } else if (getrank() == 3 && getIsAdmin() == "") {
    identity = 4;
  } else if (getrank() == 3 && getIsAdmin() == 0) {
    identity = 4;
  } else if (getrank() == 5) {
    identity = 5;
  } else if (getrank() == 10) {
    identity = 6;
  } else if (getrank() == 8) {
    identity = 7;
  }
  //   console.log(identity,'-',getrank(),'-', getIsAdmin());
  return identity;
}
// 判断手机端
export function isMobile() {
  let flag = navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );
  return flag;
}



// WEBPACK FOOTER //
// ./src/utils/auth.js